/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_To_View_PurchasesInputs */

const en_signin_to_view_purchases = /** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to view your purchases`)
};

const es_signin_to_view_purchases = /** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para ver tus compras`)
};

const fr_signin_to_view_purchases = /** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour voir vos achats`)
};

const de_signin_to_view_purchases = /** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um deine Käufe anzuzeigen`)
};

const id_signin_to_view_purchases = /** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan masuk untuk melihat pembelian Anda`)
};

/** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */
const ja_signin_to_view_purchases = en_signin_to_view_purchases;

/** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */
const zh_signin_to_view_purchases = en_signin_to_view_purchases;

/** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */
const ar_signin_to_view_purchases = en_signin_to_view_purchases;

/** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */
const it_signin_to_view_purchases = en_signin_to_view_purchases;

/** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */
const ru_signin_to_view_purchases = en_signin_to_view_purchases;

/** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */
const pt_signin_to_view_purchases = en_signin_to_view_purchases;

/** @type {(inputs: Signin_To_View_PurchasesInputs) => LocalizedString} */
const ko_signin_to_view_purchases = en_signin_to_view_purchases;

/**
* | output |
* | --- |
* | "Sign in to view your purchases" |
*
* @param {Signin_To_View_PurchasesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const signin_to_view_purchases = /** @type {((inputs?: Signin_To_View_PurchasesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_To_View_PurchasesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_to_view_purchases(inputs)
	if (locale === "es") return es_signin_to_view_purchases(inputs)
	if (locale === "fr") return fr_signin_to_view_purchases(inputs)
	if (locale === "de") return de_signin_to_view_purchases(inputs)
	if (locale === "ja") return ja_signin_to_view_purchases(inputs)
	if (locale === "zh") return zh_signin_to_view_purchases(inputs)
	if (locale === "ar") return ar_signin_to_view_purchases(inputs)
	if (locale === "id") return id_signin_to_view_purchases(inputs)
	if (locale === "it") return it_signin_to_view_purchases(inputs)
	if (locale === "ru") return ru_signin_to_view_purchases(inputs)
	if (locale === "pt") return pt_signin_to_view_purchases(inputs)
	return ko_signin_to_view_purchases(inputs)
});